import { GenericModal } from './GenericModal'

interface GenericModalWrapperProps {
    open: boolean
    onClose?: () => void
    primaryText: string
    secondaryText?: string
    primaryCTA?: string
    secondaryCTA?: string
    onPrimaryClick?: () => void
    onSecondaryClick?: () => void
    variant?: 'default' | 'success' | 'error' | 'warning' | 'info'
    disableBackdropClick?: boolean
}

const GenericModalWrapper: React.FC<GenericModalWrapperProps> = ({
    open,
    onClose,
    primaryText,
    secondaryText,
    primaryCTA,
    secondaryCTA,
    onPrimaryClick,
    onSecondaryClick,
    variant = 'default',
    disableBackdropClick = false
}) => {
    // ✅ Business logic - variant styling calculation
    const getVariantStyles = () => {
        return {
            primaryButtonColor: 'brand.primary',
            primaryButtonHover: 'brand.primaryHover',
            primaryButtonTextColor: 'brand.primaryForeground'
        }
        // TODO: Add other variants
    }

    const variantStyles = getVariantStyles()

    const handleBackdropClick = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (reason === 'backdropClick' && disableBackdropClick) {
            return
        }
        if (onClose) {
            onClose()
        }
    }

    return (
        <GenericModal
            open={open}
            onClose={onClose}
            primaryText={primaryText}
            secondaryText={secondaryText}
            primaryCTA={primaryCTA}
            secondaryCTA={secondaryCTA}
            onPrimaryClick={onPrimaryClick}
            onSecondaryClick={onSecondaryClick}
            primaryButtonColor={variantStyles.primaryButtonColor}
            primaryButtonHover={variantStyles.primaryButtonHover}
            primaryButtonTextColor={variantStyles.primaryButtonTextColor}
            disableBackdropClick={disableBackdropClick}
            handleBackdropClick={handleBackdropClick}
        />
    )
}

export { GenericModalWrapper }
export default GenericModalWrapper
export { GenericModal } from './GenericModal'
export type { GenericModalProps } from './GenericModal'
